<template>

<div v-loading="loading" class="screen-container flex-column flex-auto">
  <div v-if="myData" class="flex-column flex-auto padding-top-20 padding-lr-20">

      <el-row :gutter="20" type="flex" class="flex-auto">
        <el-col :span="6">
          <div class="myColumn flex-column" style="flex:none">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">天然气进口关键指标</div>
                </div>
              </div>
              <div class="hover-opacity" @click="$root.jump({path:'/lng/jkGjzb',blank:true})">
                <div class="flex-row justify-around border-bottom padding-bottom-10 margin-top-10" v-if="myData['天然气进口关键指标']&&myData['天然气进口关键指标'].length">
                  <div class="flex-auto flex-column align-items-center">
                    <div>
                      <div class="color-sub">
                        TTF价格
                        <span>（{{myData['天然气进口关键指标'][myData['天然气进口关键指标'].length-1]['日期']}}）</span>
                      </div>
                      <div class="bold" style="font-size: 30px; color: #93e6ff;">
                        <span>{{ myData['天然气进口关键指标'][myData['天然气进口关键指标'].length-1]['TTF价格'] }}</span>
                        <span class="font-size-14"> 美元/百万英热</span>
                      </div>
                    </div>
                  </div>
                  <div class="border-right"></div>
                  <div class="flex-auto flex-column align-items-center">
                    <div>
                      <div class="color-sub">
                        亨利港价格
                        <span>（{{myData['天然气进口关键指标'][myData['天然气进口关键指标'].length-1]['日期']}}）</span>
                      </div>
                      <div class="bold" style="font-size: 30px; color: #93e6ff;">
                        <span>{{ myData['天然气进口关键指标'][myData['天然气进口关键指标'].length-1]['亨利港价格'] }}</span>
                        <span class="font-size-14"> 美元/百万英热</span></div>
                    </div>
                  </div>
                </div>
                <div class="margin-top-10" v-if="myData['LNG综合到岸价']&&myData['LNG综合到岸价'].length">
                  <div class="text-align-center color-sub">
                    LNG综合到岸价
                    <span>（{{myData['LNG综合到岸价'][myData['LNG综合到岸价'].length-1]['日期1']}} 至 {{myData['LNG综合到岸价'][myData['LNG综合到岸价'].length-1]['日期2']}}）</span></div>
                  <div class="flex-row justify-around">
                    <div>
                      <div class="bold" style="font-size: 40px; color: #ffd000;">
                        <span>{{ myData['LNG综合到岸价'][myData['LNG综合到岸价'].length-1]['LNG综合到岸价'] }}</span>
                        <span class="font-size-20">元/吨</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">天然气月度产量</div>
                </div>
              </div>
              <Chart :option="trqydclChart" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">天然气月度消费量</div>
                </div>
              </div>
              <Chart :option="trqydxflChart" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
        </el-col>
        <el-col :span="12">
          <el-row :gutter="20" type="flex" class="flex-auto" style="flex:0 0 370px">
            <el-col :span="12">
              <div class="myColumn flex-column">
                <div class="angle angle-lt"></div>
                <div class="angle angle-rt"></div>
                <div class="angle angle-lb"></div>
                <div class="angle angle-rb"></div>
                <div class="column-con flex-column flex-auto">
                  <div>
                    <div class="flex-row align-items-center justify-between">
                        <div class="column-title">LNG分省月度消费量</div>
                        <div v-if="myData['LNG分省消费量月度']&&myData['LNG分省消费量月度'].length" class="color-sub">统计周期：{{ Object.keys(myData['LNG分省消费量月度'][0])[Object.keys(myData['LNG分省消费量月度'][0]).length-1] }}</div>
                    </div>
                  </div>
                  <Chart :option="mapChart" :legendAutoHeight="false" class="flex-auto"></Chart>
                </div>
              </div>
            </el-col>
            <el-col :span="12">
              <div class="myColumn flex-column">
                <div class="angle angle-lt"></div>
                <div class="angle angle-rt"></div>
                <div class="angle angle-lb"></div>
                <div class="angle angle-rb"></div>
                <div class="column-con flex-column flex-auto">
                  <div>
                    <div class="flex-row align-items-center justify-between">
                        <div class="column-title">LNG月度消费量</div>
                    </div>
                  </div>
                  <Chart :option="lngydxflChart" :legendAutoHeight="false" class="flex-auto"></Chart>
                </div>
              </div>
            </el-col>
          </el-row>
          <el-row :gutter="20" type="flex" class="flex-auto">
            <el-col :span="24">
              <div class="myColumn flex-column">
                <div class="angle angle-lt"></div>
                <div class="angle angle-rt"></div>
                <div class="angle angle-lb"></div>
                <div class="angle angle-rb"></div>
                <div class="column-con flex-column flex-auto">
                  <div>
                    <div class="flex-row align-items-center justify-between">
                        <div class="column-title">LNG进口船期资源流向</div>
                        <div v-if="myData['LNG进口船期资源流向']&&myData['LNG进口船期资源流向'].length" class="color-sub">统计周期：{{ myData['LNG进口船期资源流向'][0]['日期'] }}</div>
                    </div>
                  </div>
                  <Chart :option="sankeyChart" :legendAutoHeight="false" class="flex-auto"></Chart>
                </div>
              </div>
            </el-col>
          </el-row>
        </el-col>
        <el-col :span="6">

          <div class="myColumn flex-column" style="flex:none">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">LNG行业关键指标</div>
                </div>
              </div>
              <div class="hover-opacity" @click="$root.jump({path:'/lng/hyGjzb',blank:true})">
                <div class="flex-row justify-around border-bottom padding-bottom-10 margin-top-10" v-if="myData['LNG行业关键指标']&&myData['LNG行业关键指标'].length">
                  <div class="flex-auto flex-column align-items-center">
                    <div>
                      <div class="color-sub">
                        LNG工厂产量<span>（{{myData['LNG行业关键指标'][myData['LNG行业关键指标'].length-1]['日期']}}）</span>
                      </div>
                      <div class="bold" style="font-size: 30px; color: #93e6ff;">
                        <span>{{ myData['LNG行业关键指标'][myData['LNG行业关键指标'].length-1]['LNG工厂产量'] }}</span>
                        <span class="font-size-20">万吨</span>
                      </div>
                    </div>
                  </div>
                  <div class="border-right"></div>
                  <div class="flex-auto flex-column align-items-center">
                    <div>
                      <div class="color-sub">
                        LNG接收站槽批量
                        <span>（{{myData['LNG行业关键指标'][myData['LNG行业关键指标'].length-1]['日期']}}）</span>
                      </div>
                      <div class="bold" style="font-size: 30px; color: #93e6ff;">
                        <span>{{ myData['LNG行业关键指标'][myData['LNG行业关键指标'].length-1]['LNG接收站槽批量'] }}</span>
                        <span class="font-size-20">万吨</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class=" border-bottom padding-bottom-10 margin-top-10" v-if="myData['LNG上游周转库容率']&&myData['LNG上游周转库容率'].length">
                  <div class="text-align-center color-sub">
                    LNG上游周转库容率
                    <span>（{{myData['LNG上游周转库容率'][myData['LNG上游周转库容率'].length-1]['日期']}}）</span>
                  </div>
                  <div class="flex-row justify-around margin-top-10">
                    <div>
                      <div class="font-size-12">LNG工厂</div>
                      <div class="bold" style="font-size: 20px; color: #ffd000;">
                        <span>{{ myData['LNG上游周转库容率'][myData['LNG上游周转库容率'].length-1]['LNG工厂'] }}</span>
                      </div>
                    </div>
                    <div class="border-right"></div>
                    <div>
                      <div class="font-size-12">LNG接收站</div>
                      <div class="bold" style="font-size: 20px; color: #ffd000;">
                        <span>{{ myData['LNG上游周转库容率'][myData['LNG上游周转库容率'].length-1]['LNG接收站'] }}</span>
                      </div>
                    </div>
                    <div class="border-right"></div>
                    <div>
                      <div class="font-size-12">LNG周转</div>
                      <div class="bold" style="font-size: 20px; color: #ffd000;">
                        <span>{{ myData['LNG上游周转库容率'][myData['LNG上游周转库容率'].length-1]['LNG周转库容率'] }}</span>
                      </div>
                    </div>
                  </div>
                  
                </div>
                <div class="margin-top-10" v-if="myData['LNG工厂库容率']&&myData['LNG工厂库容率'].length">
                  <div class="text-align-center color-sub">
                    LNG工厂库容率
                    <span>（{{myData['LNG工厂库容率'][myData['LNG工厂库容率'].length-1]['日期']}}）</span>
                  </div>
                  <div class="flex-row justify-around flex-wrap">
                    <div :class="{'flex-column flex-auto align-items-center margin-top-10':true,'border-right':(index+1)%3&&index<myData['LNG工厂库容率'].length-1}" v-for="(item,index) in Object.keys(myData['LNG工厂库容率'][0]).filter(v=>v!='日期')" :key="index" style="width:33.3%;box-sizing: border-box;">
                      <div>
                        <div class="font-size-12">{{item}}</div>
                        <div class="bold" style="font-size: 20px;"><span>{{ myData['LNG工厂库容率'][myData['LNG工厂库容率'].length-1][item] }}</span></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title" >中国液化天然气下游消费结构（月度）</div>
                </div>
              </div>
              <div class="flex-row padding-tb-5 margin-top-5 bold" v-if="myData['液化天然气下游消费结构']&&myData['液化天然气下游消费结构'].length">
                <div class="padding-lr-10" v-for="(item,index) in Object.keys(myData['液化天然气下游消费结构'][0])" :key="index" style="flex:1">{{item}}</div>
              </div>
              <div ref="div_1" @mouseover="tableScroll.tableMouseOver_1=1" @mouseout="tableScroll.tableMouseOver_1=0" style="height:0;flex:auto;overflow:hidden; border-radius: 5px;" class=" hover-opacity" @click="$root.jump({path:'/lng/xfjg',blank:true})">
                <el-table
                  :key="$root.docWidth"
                  v-if="myData['液化天然气下游消费结构']&&myData['液化天然气下游消费结构'].length"
                  :data="myData['液化天然气下游消费结构']"
                  size="mini"
                  :show-header="false"
                  style="width: 100%">
                  <el-table-column
                    v-for="(item,index) in Object.keys(myData['液化天然气下游消费结构'][0])" :key="index"
                    :prop="item"
                    show-overflow-tooltip
                  >
                  </el-table-column>
                </el-table>
              </div>
            </div>
          </div>
          <div class="myColumn flex-column">
            <div class="angle angle-lt"></div>
            <div class="angle angle-rt"></div>
            <div class="angle angle-lb"></div>
            <div class="angle angle-rb"></div>
            <div class="column-con flex-column flex-auto">
              <div>
                <div class="flex-row align-items-center justify-between">
                    <div class="column-title">全国LNG地区成交均价</div>
                </div>
              </div>
              <Chart :option="lngdqcjChart" :legendAutoHeight="true" class="flex-auto"></Chart>
            </div>
          </div>
          
        </el-col>
      </el-row>

  </div>
</div>

</template>

<script>
import Chart from "@/components/Chart";
import '@/common/china.js'//注册echarts中国地图
import XLSX from 'xlsx';
export default {
  name: 'Home',
  components:{
    Chart,
  },
  data(){
    return {
      loading:false,
      myData:null,
      tableScroll:{
         tableMouseOver_1:0,
      }
       

    }
  },
  computed:{
    trqydclChart(){
      if(this.myData['天然气月度产量']&&this.myData['天然气月度产量'].length){
        let chartData=this.myData['天然气月度产量']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.legend.data=['中国天然气产量','同比']
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['月份']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis=[
            {
                type: 'value',
                name:'亿立方米',
                nameLocation: 'end' ,
                nameGap: 5,
                nameTextStyle:{
                align:'left'
                },
                splitLine: {
                lineStyle: {
                    type:'dashed'
                }
                },
                scale:true,
            },
            {
                type: 'value',
                name:'同比',
                nameLocation: 'end' ,
                nameGap: 5,
                
                nameTextStyle:{
                align:'right'
                },
                splitLine: {
                  show:false,
                  lineStyle: {
                      type:'dashed'
                  }
                },
                axisLabel:{
                formatter: '{value}%'
                },
            }
        ]
        opt.series=[
          {
              name:opt.legend.data[0],
              data:  chartData.map(v=>{return v[opt.legend.data[0]]}),
              type: 'bar',
              yAxisIndex:0
          },
          {
              name:opt.legend.data[1],
              data:  chartData.map(v=>{return parseFloat(v[opt.legend.data[1]])}),
              type: 'line',
              yAxisIndex:1,
          },
        ]
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} ${val.seriesName=='同比'?'%':'亿立方米'}</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    trqydxflChart(){
      if(this.myData['天然气月度消费量']&&this.myData['天然气月度消费量'].length){
        let chartData=this.myData['天然气月度消费量']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.legend.data=Object.keys(chartData[0]).filter(v=>v!='月份')
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['月份']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.name='亿立方米'
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return vv[v]}),
              type: 'bar',
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} 亿立方米</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    mapChart(){
      if(this.myData['LNG分省消费量月度']&&this.myData['LNG分省消费量月度'].length){
        let chartData=this.myData['LNG分省消费量月度']
        let cycles=Object.keys(chartData[0]).filter(v=>v!='省份')

        let opt = {
          backgroundColor: 'transparent',
          title:{
            subtext:'单位：万吨'
          },
          tooltip:{
            formatter: (params)=>{
              var str=`
                  <div>${params.seriesName}</div>
                  <div>${params.name}：${this.$numFormat(params.value,2,'-')} 万吨</div>
              `
              return str
            },
            backgroundColor: 'rgba(255, 255, 255, 0.8)',
          },
          visualMap:{
            type:'continuous',
            left:'right',
            max:Math.max(...chartData.map(v=>{return parseFloat(v[cycles[cycles.length-1]])||0})),
            mix:0,
            inRange:{
              color: ['#d7fbb1', '#5600e4'],
            },
            text:[Math.max(...chartData.map(v=>{return parseFloat(v[cycles[cycles.length-1]])||0})),0],
            
          },
          series:[{
            type:'map',
            map:'china',    
            name:'LNG月度消费量',
            roam: true,

            boundingCoords: [
                // 定位左上角经纬度
                [78, 53],
                // 定位右下角经纬度
                [130, 20]
            ],
            selectedMode: false,
            itemStyle:{
              areaColor:'rgba(160,160,160,0.3)',
              borderColor:'#00fffc',
            },
            emphasis:{
              itemStyle:{
                areaColor:'rgba(160,160,160,0.3)',
                borderColor:'#fff',
              },
              label:{
                show:true,
              }
            },

            data:chartData.map(v=>{
              return {
                name:v['省份'],
                value:v[cycles[cycles.length-1]],
                // tooltip:{
                //   formatter: '{b}: {c}'
                // },
                emphasis:{
                  itemStyle:{
                      areaColor:'#ffc069'
                  }
                }
              }
            })
          }]
        }
        return opt
      }
      else{
        return null
      }
      
    },
    lngydxflChart(){
      if(this.myData['LNG月度消费量']&&this.myData['LNG月度消费量'].length){
        let chartData=this.myData['LNG月度消费量']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.legend.data=Object.keys(chartData[0]).filter(v=>v!='月份')
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['月份']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.yAxis.name='万吨'
        opt.series=opt.legend.data.map(v=>{
          return {
              name:v,
              data:  chartData.map(vv=>{return vv[v]}),
              type: 'bar',
          }
        })
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} 万吨</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
    sankeyChart(){
      if(this.myData['LNG进口船期资源流向']&&this.myData['LNG进口船期资源流向'].length){
        let chartData=this.myData['LNG进口船期资源流向']
        let origin = chartData.reduce((groups, cur) => {
            const key = cur['来源国']+" ";
            if (!groups[key]) {
              groups[key] = [];
            }
            groups[key].push(cur);
            return groups;
          }, {});
        let destination = chartData.reduce((groups, cur) => {
          const key = cur['目的地']+"  ";
          if (!groups[key]) {
            groups[key] = [];
          }
          groups[key].push(cur);
          return groups;
        }, {});
        let data= [],
            items={...origin,...destination};
        for(let key in items){
          
            data.push({
              name:key,
              value: this.$numFormat(items[key].reduce((prev,cur)=>{ return prev + (parseFloat(cur['数量'])||0) }, 0),2)
            })
          
        }
        let opt = {
          backgroundColor: 'transparent',
          title:{
            subtext:'单位：万吨'
          },
          tooltip:{
            formatter:(params)=>{
              let str=`<div>${params.name}:${this.$numFormat(params.value,2,'-')}</div>`
              return str
            }
          },
          series: {
            type: 'sankey',
            nodeGap:12,
            lineStyle:{
              color:'gradient'
            },
            top:10,
            bottom:10,
            right:130,
            left:70,
            label:{
              show:true,
              formatter: '{b}: {c}'
            },
            emphasis: {
              focus: 'adjacency'
            },
            data: data,
            
            labelLayout:{
              moveOverlap:'shiftX'
            },
            links: chartData.map(v=>{
              return {
                source: v['来源国']+" ",
                target: v['目的地']+"  ",
                value: v['数量']
              }
            })
          }
        }
        return opt
      }else{
        return null
      }
    },
    lngdqcjChart(){
      if(this.myData['全国LNG地区成交均价']&&this.myData['全国LNG地区成交均价'].length){
        let chartData=this.myData['全国LNG地区成交均价']
        let opt =JSON.parse(JSON.stringify(this.$defaultChartOption)) 
        opt.grid.right=50
        opt.yAxis.name = '元/吨'
        opt.xAxis.boundaryGap = true
        opt.xAxis.data=chartData.map(v=>{return v['日期']})
        opt.xAxis.axisLabel={
          showMinLabel:true,
          showMaxLabel:true,
          rotate:-45,
        }
        opt.series=[
          {
              name:'价格',
              data:  chartData.map(v=>{return v['价格']}),
              type: 'line',
              endLabel:{
                show:true,
                fontWeight:'bold',
              },         
              labelLayout:{ moveOverlap:'shiftY'},
          },
        ]
        opt.tooltip={
          trigger:'axis',
          formatter: (params)=>{
            var str=`<div>${params[0].axisValue}</div>`
            params.forEach((val)=>{
                str+=`<div>${val.marker}${val.seriesName}：${this.$numFormat(val.data,2,'-')} 元/吨</div>`
            })
            return str
          },
        }
        return opt
      }else{
        return null
      }
      
    },
  },
  created(){
    this.getData()
  },
  methods:{
    scroll(element,step){
       let obj=this.$refs[element]
       obj.scrollHeight>obj.clientHeight&&(obj.innerHTML+=obj.innerHTML);
       let fun=()=>{
        if(obj.scrollTop%step||!this.tableScroll[`tableMouseOver_${element.split('_')[1]}`]){
            obj.scrollTop++
            obj.scrollTop%=obj.scrollHeight>>1
          }
        setTimeout(fun,obj.scrollTop%step?10:3000)
       }
       fun()
    },
    getData(){
      this.loading=true
      this.$instance.get('/data/lng/LNG_DATA.xlsx',{
        baseURL:window.location.href.split('#')[0],
        responseType:'arraybuffer',
        headers: {
          'Content-Type': 'application/vnd.ms-excel', // 或 application/vnd.openxmlformats-officedocument.spreadsheetml.sheet
        },
      })
      .then(res=>{
        this.$message.closeAll()
        this.loading=false
        let data = new Uint8Array(res.data)
        let wb = XLSX.read(data, {type:"array"})
        let sheets = wb.Sheets // 获取文档数据
        let myData={}
        for(let key in sheets){
          myData[key]=XLSX.utils.sheet_to_json(sheets[key],{raw:false})
        }
        this.myData=myData
        this.$nextTick(()=>{
          this.init()
        })
        console.log(myData)

      })
      .catch(()=> {
        this.loading=false
      }); 
    },
    init(){
      this.$nextTick(()=>{this.scroll('div_1',36)})
    }
  },
  mounted(){
   
  },
  watch: {
   
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">

</style>
<style scoped lang="scss">
@import './assets/css/common.scss';
</style>
